import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { apiRoute as api, ApiFloorType, PlansColonieType, fetchJson } from '../helpers/ApiHelper';
import { getCompleteLocale } from '../helpers/LangHelper';

type FloorType = {
  id: number;
  slug: string;
  image: string;

  name: string;
  description: string;
};

export default function FloorsPreview() {
  const { t, i18n } = useTranslation('', { keyPrefix: 'Camp' });

  const [pdfs, setPdfs] = useState<PlansColonieType>();
  const [floors, setFloors] = useState<FloorType[]>();

  useEffect(() => {
    // Get PDFs
    fetchJson<{ data: PlansColonieType }>(`${api}/items/PlansDeLaColonie`)
      .then((json) => {
        setPdfs(json.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn(err);
      });

    // Get Floors
    fetchJson<{ data: ApiFloorType[] }>(`${api}/items/Floors?fields=*,translations.*`)
      .then((json) => {
        setFloors(
          json.data.map(
            (floor: ApiFloorType) =>
              ({
                ...floor,
                name: floor.translations.find(
                  (trans) => trans.languages_code === getCompleteLocale(i18n.resolvedLanguage)
                )?.name,
                description: floor.translations.find(
                  (trans) => trans.languages_code === getCompleteLocale(i18n.resolvedLanguage)
                )?.description,
              } as unknown as FloorType)
          )
        );
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn(err);
      });
  }, [i18n.resolvedLanguage]);

  const [activeFloorId, setActiveFloorId] = useState<number>(1);

  return (
    <div id="campBuildingFloors">
      <h3>{t('floorsPlan')}</h3>

      <div className="colRight">
        <fieldset className="btnLine">
          {floors &&
            floors.map((floor) => (
              <label
                key={floor.id}
                htmlFor={`floor${floor.id}`}
                className={floor.id === activeFloorId ? 'checked' : ''}
              >
                <input
                  type="radio"
                  name="floor"
                  id={`floor${floor.id}`}
                  value={floor.id}
                  checked={floor.id === activeFloorId}
                  onChange={() => setActiveFloorId(floor.id)}
                />
                {floor.name}
              </label>
            ))}
        </fieldset>
        {activeFloorId && floors?.find((f) => f.id === activeFloorId) ? (
          <div className="floorDescription">
            <h6>{floors.find((f) => f.id === activeFloorId)?.name}</h6>
            <p>{floors.find((f) => f.id === activeFloorId)?.description}</p>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="colLeft">
        {activeFloorId && floors?.find((f) => f.id === activeFloorId) ? (
          <img src={`${api}/assets/${floors.find((f) => f.id === activeFloorId)?.image}`} alt="" />
        ) : (
          ''
        )}
        {pdfs && (
          <>
            <Link to={`${api}/assets/${pdfs.campFloors}`} target="_blank">
              {t('downloadFloorPlan')}
            </Link>

            <Link to={`${api}/assets/${pdfs.campExterior}`} target="_blank">
              {t('downloadExtPlan')}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
